import { useState, useEffect, useContext } from 'react';
import { fetchAdmins } from '../../../firebase/utils';
import RoleTable from '../../pages-partial/Role-Management/RoleTable';
import Loader from '../../../Common/Component/Loader';
import AdminContext from '../../../Helper/admin';

const RoleManagement = () => {
  const [loading, setLoading] = useState(true);
  const { setAdminRoles, adminRoles } = useContext(AdminContext);

  const fetchAdminData = async () => {
    try {
      setLoading(true);
      if (!adminRoles) {
        const adminList = await fetchAdmins();
        setAdminRoles(adminList);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminData();
  }, []);

  return (
    <div>
      {loading ? <Loader /> :
        <RoleTable
          adminData={adminRoles}
          setAdmins={setAdminRoles}
          loading={loading} />
      }
    </div>
  );
};

export default RoleManagement;